import { WINDOWS_TO_IANA } from '../constants/timezone.constants';

export class TimeZoneUtilities {

    /**
     * Converts a Windows timezone ID (e.g. "Eastern Standard Time") to its IANA equivalent
     * (e.g. "America/New_York"). If the input is already an IANA name (contains "/") or
     * equals "UTC", it is returned unchanged. If the input is null/empty or an unrecognized
     * Windows-style ID, returns undefined so the caller can fall back to the browser's
     * default timezone (passing an invalid string to Intl.DateTimeFormat throws).
     */
    public static toIanaTimeZone(timeZoneId: string | null | undefined): string | undefined {
        if (!timeZoneId) {
            return undefined;
        }

        if (WINDOWS_TO_IANA[timeZoneId]) {
            return WINDOWS_TO_IANA[timeZoneId];
        }

        if (timeZoneId.includes('/') || timeZoneId === 'UTC') {
            return timeZoneId;
        }

        return undefined;
    }

    /**
     * Strips the leading "(UTC±HH:MM) " (or "(UTC) ") offset prefix from a .NET
     * TimeZoneInfo display name, e.g. "(UTC-05:00) Eastern Time (US & Canada)" ->
     * "Eastern Time (US & Canada)".
     */
    public static stripUtcOffset(displayName: string | null | undefined): string {
        if (!displayName) {
            return '';
        }

        return displayName.replace(/^\(UTC[^)]*\)\s*/, '');
    }
}
